var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71266 0.277628C10.0058 0.570305 10.0061 1.04518 9.71344 1.33829L6.34119 4.71487C6.18523 4.87103 6.18522 5.12401 6.34118 5.28018L9.71344 8.65709C9.98173 8.92577 10.0038 9.34719 9.77984 9.64099L9.71266 9.71775C9.41955 10.0104 8.94468 10.0101 8.652 9.71696L5.28201 6.34188C5.12574 6.18537 4.8721 6.18539 4.71585 6.34194L1.34713 9.71696C1.05445 10.0101 0.579577 10.0104 0.286468 9.71775C-0.00664156 9.42507 -0.00699211 8.9502 0.285685 8.65709L3.65752 5.28016C3.81345 5.12399 3.81345 4.87105 3.65751 4.71489L0.285685 1.33829C0.0173976 1.0696 -0.00466508 0.648188 0.21929 0.354383L0.286468 0.277628C0.579577 -0.0150487 1.05445 -0.0146982 1.34713 0.278411L4.7159 3.6524C4.87214 3.80888 5.1257 3.8089 5.28197 3.65245L8.652 0.278411C8.94468 -0.0146982 9.41955 -0.0150487 9.71266 0.277628Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8396855af791aa8239141760313c91ed.svg";
export { ForwardRef as ReactComponent };